var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider"},[_c('input',{attrs:{"type":"range","step":_vm.step,"min":_vm.min,"max":_vm.max,"list":_vm.list,"aria-label":_vm.ariaLabel},domProps:{"value":_vm.value},on:{"change":_vm.onChange}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }